<template>
    <div class="balloon-message">
        <h2> {{ title }} </h2>
        <h1> {{ subtitle}} </h1>
    </div>
</template>

<script>
    export default {
        props: {
            title: {
                type: String
            },

            subtitle: {
                type: String
            }
        }
    }
</script>

<style lang="scss" scoped>
@import '@/assets/variables';

.balloon-message {
    width: fit-content;
    max-width: 39.3125rem;
    border-radius: 0.625rem;
    padding: 3.75rem;

    background-color: rgba(250, 250, 250, .25);
    backdrop-filter: blur(.625rem);
    text-align: left;

    @media (max-width: $breakpoint-small){
        padding: 1.75rem;
    }
}

h1 {
    font-size: 4.5rem;
    font-weight: 700;
    color: black;

    @media (max-width: $breakpoint-small) {
        font-size: 2.25rem;
    }

}

h2 {
    font-size: 3.75rem;
    font-weight: 700;
    color: black;

    @media (max-width: $breakpoint-small) {
        font-size: 1.625rem;
    }

}

</style>